/**
 * 게시글 상세 조회를 위한 React Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { boardService } from '../../features/admin/services/boardService';
import { BoardItem } from '../types/board.types';

interface UseBoardDetailOptions {
  enabled?: boolean;
}

/**
 * 게시글 상세를 조회하는 Hook
 * @param boardType - 게시판 타입 (news, gallery, bulletin, sunday-school 등)
 * @param id - 게시글 ID
 * @param options - 활성화 여부 옵션
 */
export const useBoardDetail = (
  boardType: string,
  id: number | undefined,
  options: UseBoardDetailOptions = {}
) => {
  const { enabled = true } = options;

  return useQuery<BoardItem>({
    queryKey: ['board', boardType, 'detail', id],
    queryFn: async () => {
      if (!id) {
        throw new Error('게시글 ID가 필요합니다.');
      }
      const response = await boardService.getPost(boardType, id);
      return response;
    },
    // staleTime, gcTime은 App.tsx의 기본 설정 사용
    // (목록 <-> 상세 페이지 이동 시 캐시 활용)
    enabled: enabled && !!id, // ID가 있을 때만 쿼리 실행
  });
};
